<script lang="ts">
  import { isSupportedUSCountry, optimalUSCountry } from '$lib/country';
  import { defaultRegion, locations, currentLocation, isLocation } from '$lib/region';
  import { user } from '$lib/stores/user';
  import { cn } from '$lib/utils';
  import { objectKeys } from '$lib/utils/object';
  import { buildPath } from '$lib/utils/paths';
  import type { Selected } from 'bits-ui';
  import Select from './ui/select/select.svelte';
  import { defaultLang } from '$lib/lang';

  let className: string | undefined = undefined;
  export { className as class };

  const onChange = async (e: CustomEvent<Selected<keyof typeof locations> | undefined>) => {
    if (e.detail) {
      const extractedCountry = e.detail.value.toUpperCase();
      const extractedLocation = isLocation(e.detail.value) ? e.detail.value : defaultRegion;

      if (extractedCountry && isSupportedUSCountry(extractedCountry)) {
        optimalUSCountry.set(extractedCountry);
        await user.updateCartIdentity();
      } else {
        optimalUSCountry.set(null);
        await user.updateCartIdentity();
      }

      // reload window when changing region to make sure all data is fresh and appropriate for the region
      window.location.href = $buildPath({
        region: extractedLocation,
        lang: defaultLang
      });
    }
  };

  let value: string = $currentLocation;

  $: items = objectKeys(locations).map((region) => ({
    value: region,
    label: locations[region]?.currencySymbol
  }));
</script>

<div class="flex gap-1 items-center">
  <div class="rounded-micro overflow-hidden w-5 h-4">
    <img
      src={locations[value]?.flag}
      alt={locations[value]?.name}
      class="w-full h-full object-cover"
    />
  </div>
  <Select
    variant="link"
    bind:value
    {items}
    on:change={onChange}
    class={cn(className, 'text-sm')}
    sameWidth={false}
    popoverClass="min-w-28"
    size="sm"
  />
</div>
